import Swiper, {Navigation, Pagination, Lazy} from "swiper";
Swiper.use([Navigation, Pagination, Lazy]);

const initReviewsSlider = () => {
  const sliderContainer = document.querySelector("[data-reviews-slider]");
  sliderContainer && new Swiper(sliderContainer, {
    autoHeight: true,
    lazy: true,
    spaceBetween: 16,
    breakpoints: {         
      997: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },              
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },       
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
    },
    pagination: {
      el: "[data-reviews-slider-container] .swiper-pagination",
      clickable: true,
      bulletElement: "button",
      dynamicBullets: true,
      dynamicMainBullets: 6,
    },
    navigation: {
      nextEl: "[data-reviews-slider-container] .slider-navigation__button--next",
      prevEl: "[data-reviews-slider-container] .slider-navigation__button--prev",
    },
  });  
};

export default initReviewsSlider;
